import axios from "../api";
/**
 * `POST /player-comparison` — per requested player (input order): the full
 * detailed card plus the solver's category breakdown of its meta rating.
 * `playerRoleId` grades every player under that role; omitted, each player is
 * graded under their own best zero-chem role.
 */
export const createPlayerComparison = async (players, playerRoleId) => {
    const res = await axios.post("/player-comparison", { players, playerRoleId });
    return res.data.map(({ player, comparisons }) => ({
        player: {
            ...player,
            positions: Array.from(new Set([player.preferredPosition, ...player.possiblePositions])),
        },
        comparisons,
    }));
};
//# sourceMappingURL=createPlayerComparison.js.map